
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vender/[venderUrlId]",
      function () {
        return require("private-next-pages/vender/[venderUrlId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vender/[venderUrlId]"])
      });
    }
  